<template>
  <v-dialog v-model="dialog" max-width="400">
    <template #activator="{ on }">
      <v-btn outlined small v-on="on" color="#FF347C">
        Edit Email <v-icon right> mdi-email-edit-outline </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title> Edit user email </v-card-title>
      <v-card-text class="text--primary">
        <v-form ref="form" @submit.prevent="onEdit">
          <v-text-field
            v-model="email"
            append-icon="mdi-email-edit-outline"
            label="Email"
            type="email"
            autocomplete="disabled"
            :rules="[rules.required, rules.email]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn class="ml-auto" color="#29284c" text :loading="loading" @click="dialog = false">
          Close
          <v-icon right> mdi-close </v-icon>
        </v-btn>
        <v-btn class="ml-2" dark color="#29284c" :loading="loading" @click="onEdit">
          Save
          <v-icon right> mdi-email-check-outline </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { changeTeacherEmail, changeStudentEmail } from "@/api/api";
import rulesMixin from "@/mixins/rulesMixin";

export default {
  props: {
    user: Object,
  },
  mixins: [rulesMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      email: this.user.email,
    };
  },
  methods: {
    async onEdit() {
      try {
        this.loading = true;
        if (this.user.role === "TEACHER") {
          await changeTeacherEmail(this.user.uuid, this.email);
        } else {
          await changeStudentEmail(this.user.uuid, this.email);
        }
        this.user.email = this.email;
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
